export function buildTakseeTransaction (takseeTransaction) {
    return {
        id: takseeTransaction.id,
        idExternal: takseeTransaction.id_external,
    }
}
